import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/opendyslexic/400.css";
import "@fontsource/opendyslexic/700.css";
import "@/index.css";
import App from "@/App";
import { installAxiosNativeDebug } from "@/utils/axiosNativeDebug";
import { installOverflowDebugger } from "@/utils/debugOverflow";

installAxiosNativeDebug();
installOverflowDebugger();

// Cattura info utili sugli errori runtime (anche in produzione) senza mostrarle di default.
// Si visualizzano nell'ErrorBoundary solo con ?debugErrors=1 o localStorage.debugErrors=1.
function installGlobalErrorCapture() {
  try {
    const store = (payload) => {
      try {
        window.__SP_LAST_ERROR__ = {
          ...payload,
          at: Date.now(),
        };
      } catch {
        // ignore
      }
    };

    window.addEventListener('error', (evt) => {
      store({
        type: 'error',
        message: String(evt?.message || ''),
        filename: String(evt?.filename || ''),
        lineno: Number(evt?.lineno || 0),
        colno: Number(evt?.colno || 0),
        stack: String(evt?.error?.stack || ''),
      });
    });

    window.addEventListener('unhandledrejection', (evt) => {
      const reason = evt?.reason;
      store({
        type: 'unhandledrejection',
        message: String(reason?.message || reason || ''),
        filename: String(reason?.fileName || ''),
        lineno: Number(reason?.lineNumber || 0),
        colno: Number(reason?.columnNumber || 0),
        stack: String(reason?.stack || ''),
      });
    });
  } catch {
    // ignore
  }
}

installGlobalErrorCapture();

// Safety net: se in passato era stato registrato un Service Worker (PWA),
// potrebbe continuare a intercettare fetch (incluse chiamate /api/*) e causare
// 404 “fantasma” o cache stale. L'app attuale non usa SW, quindi li rimuoviamo.
async function unregisterLegacyServiceWorkers() {
  try {
    if (!('serviceWorker' in navigator)) return;
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));

    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    // ignore
  }
}

void unregisterLegacyServiceWorkers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
